import {
  IUserBookingStatus,
  EType as EUserBookingStatusType,
} from '../repositories/newbuilding-flat-tour-booking/entities/Models/UserBookingStatus';
import { EOrderStatusType, IOrderStatus } from '../types/newbuilding/flatViewOrderInfo';

export function transformUserBookingStatus(status: IUserBookingStatus): IOrderStatus {
  const type = status.type === EUserBookingStatusType.SignedUp ? EOrderStatusType.SignedUp : EOrderStatusType.NoActive;

  const description = status.description;

  return {
    type,
    description,
  };
}
